import { render, staticRenderFns } from "./ConfiguratorDetail.vue?vue&type=template&id=43aebfad&scoped=true"
import script from "./ConfiguratorDetail.vue?vue&type=script&lang=js"
export * from "./ConfiguratorDetail.vue?vue&type=script&lang=js"
import style0 from "./ConfiguratorDetail.vue?vue&type=style&index=0&id=43aebfad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aebfad",
  null
  
)

export default component.exports